import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useClubHasMemberships_club$key } from "./__generated__/useClubHasMemberships_club.graphql";

export const useClubHasMemberships = (
  clubRef?: useClubHasMemberships_club$key | null
) => {
  const club = useFragment(useClubHasMembershipsFragmentString, clubRef);

  return club?.supportsPublic && (club?.memberships?.count ?? 0) > 0;
};

const useClubHasMembershipsFragmentString = graphql`
  fragment useClubHasMemberships_club on Club {
    supportsPublic
    memberships: packages(packageType: MEMBERSHIP, saleAvailability: PUBLIC) {
      count
    }
  }
`;
